import { render, staticRenderFns } from "./Model1.vue?vue&type=template&id=3c959cee&scoped=true"
import script from "./Model1.vue?vue&type=script&lang=js"
export * from "./Model1.vue?vue&type=script&lang=js"
import style0 from "./Model1.vue?vue&type=style&index=0&id=3c959cee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c959cee",
  null
  
)

export default component.exports